import React, { ReactNode } from 'react'
import { IOption } from '../../forms/search-input/BpSearchInput'

interface CountryFlagProps {
  code?: string
}

interface ICountryOptionProps {
  code?: string
  label: ReactNode
}

const CountryFlag = ({ code }: CountryFlagProps) =>
  code ? (
    <span
      className={`fi fis fi-${code.toLowerCase()} inline-block !h-[24px] !w-[24px] rounded-full`}
    />
  ) : null

export const CountryOption = ({ code, label }: ICountryOptionProps) => {
  return (
    <div className={'flex items-center gap-[8px]'}>
      <CountryFlag code={code} />
      <div>{label}</div>
    </div>
  )
}

/** optionRender для селектов стран: флаг слева от названия */
export const renderCountryOption = (option: IOption, label: ReactNode) => (
  <CountryOption code={option.code} label={label} />
)
